import { types } from 'mobx-state-tree';
import { RequestStateModel } from 'store/models/general-models';

export const OthersStatusesModel = types.model('Statuses', {
  personsList: types.optional(RequestStateModel, {}),
  createPerson: types.optional(RequestStateModel, {}),
  employeesList: types.optional(RequestStateModel, {}),
  createEmployee: types.optional(RequestStateModel, {}),
  providersList: types.optional(RequestStateModel, {}),
  createProvider: types.optional(RequestStateModel, {}),
});
